export default "__VITE_ASSET__DtlZu4t0__"